import { pensionTypeDefaultOrNull, pensionTypesMap } from './PensionWorkflowHelpers';
import { LUMP_SUM, HAS_LUMP_SUM, HAS_MONTHLY_PAYMENT } from './PensionWorkflowConstants';
import { isNumeric } from '../../../js/app/react/validators';

export const validateDoYouHavePension = hasPension => () => {
  const errors = [];
  if (hasPension !== true && hasPension !== false) {
    errors.push('Please select an option');
  }
  return errors;
};
export const validatePensions = (pensionsArg, pensionTypes) => () => {
  const errors = [];
  const localPensionTypesMap = pensionTypesMap(pensionTypes);

  const pensions = pensionsArg.filter((pension) => {
    const keys = Object.keys(pension);
    let nonEmptyKeys = 0;
    keys.forEach((key) => {
      if (pension[key] && pension[key] !== '') {
        nonEmptyKeys += 1;
      }
    });
    return nonEmptyKeys > 0;
  });

  for (let i = 0; i < pensions.length; i += 1) {
    const selected = pensionTypeDefaultOrNull(localPensionTypesMap, pensions[i]);
    let amountType = HAS_MONTHLY_PAYMENT;
    if (((selected || {}).extra || {}).value === LUMP_SUM) {
      amountType = HAS_LUMP_SUM;
    }

    if (pensions[i].IsDeleted) {
      if (!pensions[i].Id) {
        errors.push('Cannot delete this pension because it has an invalid ID');
        break;
      }
    } else {
      if (!selected) {
        errors.push('Please specify a valid pension type');
        break;
      }

      if (amountType === HAS_MONTHLY_PAYMENT) {
        if (!isNumeric(pensions[i].MonthlyPayment)) {
          errors.push('Please specify a valid monthly payment');
          break;
        }
      } else if (amountType === HAS_LUMP_SUM) {
        if (!isNumeric(pensions[i].LumpSumAmount)) {
          errors.push('Please specify a valid lump sum amount');
          break;
        }
      }

      if (!pensions[i].DistributionAtRetirement) {
        if (!isNumeric(pensions[i].DistributionAge)) {
          errors.push('Please specify a valid distribution age');
          break;
        }
      }
    }
  }
  return errors;
};
